@if (project$ | async; as project) {
  @if (history$ | async; as history) {
    <ng-container *transloco="let t">
      @if (
        (isHistoryAllowed$ | async) === true && history.totalElements > 0
        ) {
        <nt-export-warning [project]="project"></nt-export-warning>
        <div class="nt-container__row" id="history">
          <nt-general-card [title]="title$ | async" appearance="full-width">
            <article class="nt-container transparent">
              <header class="nt-history__heading">
                <span>{{ getHeading(history.totalElements) }}</span>
                @if (project.slug === 'nt' || project.slug === 'no') {
                  <button
                    mat-flat-button
                    color="primary"
                    class="nt-export-button"
                    (click)="print()"
                    >
                    {{ t('test.export_as_pdf') }}
                  </button>
                }
              </header>
              <nt-table
                [action]="action"
                tableTranslatePrefix="history"
                [columns]="columns"
                [data]="history"
                [paginator]="paginator"
                [sort]="sort"
                >
              </nt-table>
            </article>
          </nt-general-card>
        </div>
      }
      @if (
        (isHistoryAllowed$ | async) === true && history.totalElements === 0
        ) {
        <nt-functional-cookie
          [language]="language$ | async"
          [functionalCookiesEnabled]="true"
          [cookieWidgetEnabled]="project.enable_cookie_widget"
        ></nt-functional-cookie>
      }
      @if ((isHistoryAllowed$ | async) === false) {
        <nt-functional-cookie
          [language]="language$ | async"
          [functionalCookiesEnabled]="false"
        ></nt-functional-cookie>
      }
    </ng-container>
  }
}
